import {
    PortfolioCentralCancellationPolicyDetail,
    PortfolioCentralPaymentPolicyDetail,
} from '@mews-commander/data-access';

export type PolicyData = PortfolioCentralCancellationPolicyDetail | PortfolioCentralPaymentPolicyDetail;

export enum AssignPropertiesSegment {
    PropertyGroups = 'propertyGroups',
    Properties = 'properties',
}

export enum AssignPropertiesFieldNames {
    Properties = 'properties',
    PropertyGroups = 'propertyGroups',
    Segment = 'segment',
}
